import React from "react";
import PropTypes from "prop-types";
import kup10 from "../../img/belts/10.Kup.png";
import kup09 from "../../img/belts/09.Kup.png";
import kup08 from "../../img/belts/08.Kup.png";
import kup07 from "../../img/belts/07.Kup.png";
import kup06 from "../../img/belts/06.Kup.png";
import kup05 from "../../img/belts/05.Kup.png";
import kup04 from "../../img/belts/04.Kup.png";
import kup03 from "../../img/belts/03.Kup.png";
import kup02 from "../../img/belts/02.Kup.png";
import kup01 from "../../img/belts/01.Kup.png";
import poom from "../../img/belts/11.Poom.png";
import dan from "../../img/belts/11.Dan.png";

import { Avatar, Card } from "@mui/material";

const beltSizes = {
  small: {
    width: "50px",
  },
  medium: {
    width: "100px",
  },
  large: {
    width: "150px",
  },
};

const belts = [
  {
    id: "10.Kup",
    img: kup10,
  },
  {
    id: "09.Kup",
    img: kup09,
  },
  {
    id: "08.Kup",
    img: kup08,
  },
  {
    id: "07.Kup",
    img: kup07,
  },
  {
    id: "06.Kup",
    img: kup06,
  },
  {
    id: "05.Kup",
    img: kup05,
  },
  {
    id: "04.Kup",
    img: kup04,
  },
  {
    id: "03.Kup",
    img: kup03,
  },
  {
    id: "02.Kup",
    img: kup02,
  },
  {
    id: "01.Kup",
    img: kup01,
  },
  {
    id: "Poom",
    img: poom,
  },
  {
    id: "Dan",
    img: dan,
  },
  {
    id: "Dan",
    img: dan,
  },
  {
    id: "Dan",
    img: dan,
  },
  {
    id: "Dan",
    img: dan,
  },
  {
    id: "Dan",
    img: dan,
  },
  {
    id: "Dan",
    img: dan,
  },
];

const getBeltIndex = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  const index = Math.trunc(parsed);
  if (index < 0) {
    return 0;
  }
  if (index >= belts.length) {
    return belts.length - 1;
  }
  return index;
};

function BeltAvatar(props) {
  const { size, beltNumber, onlyBelt, justify } = props;
  const beltIndex = getBeltIndex(beltNumber);
  const belt = belts[beltIndex];
  const beltSize = beltSizes[size] || beltSizes.medium;

  if (onlyBelt) {
    return (
      <div style={{ justifyContent: justify ?? "center", display: "flex" }}>
        <Avatar
          alt={belt.id}
          src={belt.img}
          style={beltSize}
        >
          {belt.id}
        </Avatar>
      </div>
    );
  }

  return (
    <Card
      sx={{
        // maxWidth: 170,
        padding: "5px 0px",
        justifyContent: "center",
        display: "flex",
      }}
      style={{
        borderRadius: "4px",
        backgroundColor: beltIndex > 2 ? "lightgrey" : "black",
        alignContent: "center",
      }}
    >
      <Avatar
        alt={belt.id}
        src={belt.img}
        style={beltSize}
      >
        {belt.id}
      </Avatar>
    </Card>
  );
}

BeltAvatar.propTypes = {
  size: PropTypes.string,
  beltNumber: PropTypes.number,
};

// Set default props
BeltAvatar.defaultProps = {
  beltNumber: 0,
};

export default BeltAvatar;
